<h2 mat-dialog-title>Redirect Notice</h2>
<mat-dialog-content>
  <p>{{"ExternalLink.Redirect" | translate}} <strong>{{ url }}</strong>.</p>
  <p>{{"ExternalLink.Stay" | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" class="grey-button">{{"General.Close" | translate}}</button>
  <button mat-button [mat-dialog-close]="true" class="blue-button">{{"General.Continue" | translate}}</button>
</mat-dialog-actions>